import { SOURCE_LIST } from './const'

// ------------------待审批列表页------------------
export const SEARCH_SCHEMA = [
  {
    itemName: 'name',
    label: '企业名称',
    type: 'input',
  },
  {
    itemName: 'code',
    label: '企业ID',
    type: 'input',
  },
  {
    itemName: 'applyRangeDate',
    label: '申请日期',
    type: 'rangePicker',
    format: 'YYYY-MM-DD',
    allowClear: true,
  },
  {
    itemName: 'id',
    label: '申请流水号',
    type: 'input',
  },
  {
    itemName: 'source',
    label: '申请来源',
    type: 'select',
    selectList: SOURCE_LIST,
  },
  {
    itemName: 'sn',
    label: 'CRM流水号',
    type: 'input',
  },
]

// 批量申请待审批列表
export const BATCH_SEARCH_SCHEMA = [
  {
    itemName: 'id',
    label: '申请流水号',
    type: 'input',
  },
  {
    itemName: 'applyRangeDate',
    label: '申请日期',
    type: 'rangePicker',
    format: 'YYYY-MM-DD',
    allowClear: true,
  },
]

export const BATCH_BASE_INFO_SCHEMA = {
  total: {
    label: '企业申请数量',
  },
  type: {
    label: '信用类型',
    slotName: 'type',
  },
  totalAmount: {
    label: '申请总金额(元)',
    filter: 'formatAmount',
  },
  maxAmount: {
    label: '最高申请金额(元)',
    filter: 'formatAmount',
  },
  fileName: {
    label: '下载申请名单',
    slotName: 'filename',
  },
}

export const PERIOD_BATCH_BASE_INFO_SCHEMA = {
  total: {
    label: '企业申请数量',
  },
  fileName: {
    label: '下载申请名单',
    slotName: 'filename',
  },
}

export const BATCH_SCHEMA = [
  {
    itemName: 'id',
    label: '申请流水号',
    type: 'input',
  },
  {
    itemName: 'applyRangeDate',
    label: '申请日期',
    type: 'rangePicker',
    allowClear: true,
  },
]